import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page5() {
  useEffect(() => {
    document.title = "Маяк — Страница 4"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page3" />
        <ForwardLink href="/page5" />
      </div>

      <p style={{ textAlign: "right" }}>4.</p>
      <p>Он входит в спальные помещения...</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – ПРОДОЛЖЕНИЕ</p>
      <p><u>БУХ</u>! МОЛОДОЙ ударяется головой о низкий потолок...</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (себе под нос)<br/>
        Сукин...<br/>
      </p>
      <p>Он оправляется...</p>
      <p>
        Кубрик тоже унылый. Нет ничего кроме двух провисших<br/>
        чугунных односпальных кроватей.<br/>
      </p>
      <p>СТАРИК стоит возле своей кровати, МОЧИТСЯ В СВОЙ НОЧНОЙ ГОРШОК.</p>
      <p>Пауза. МОЛОДОЙ поглощен этой сценой.</p>
      <p>
        МОЛОДОЙ подходит к свободной кровати и садится. Как только<br/>
        он это делает, СТАРИК <u>ПЕРДИТ</u> примерно в трех футах от лица МОЛОДОГО.<br/>
        Сознательная демонстрация силы.
      </p>
      <p>Пауза.</p>
      <p>
        СТАРИК заканчивает справлять нужду. Он трясет своим членом.<br/>
        Застегивает пуговицы и пинает горшок под кровать. Моча почти<br/>
        выплескивается. К счастью, этого не случилось.<br/>
      </p>
      <p>СТАРИК хромает, насвистывая (песню «Tis Brasswork»).</p>
      <p>Он делает короткую паузу...</p>
      <p><u>ПЕРДИТ</u> снова.</p>
      <p>
        Он покидает кадр, исчезает его НЕРОВНАЯ ПОХОДКА: идет-хромая,<br/>
        хромает, хромает...
      </p>
      <p>
        МОЛОДОЙ сидит на своей кровати. Все еще кипит. Он недоволен.<br/>
        Но старается удержать это в себе. Он держится за голову.
      </p>
      <p>ЧАСЫ внизу тикают...</p>
      <p>Затем МОЛОДОЙ чувствует что-то странное под ним...</p>
      <p>Он ощущает...</p>
      <p>Он обнаруживает дыру в матрасе. Что-то торчит...</p>
      <p>Засовывает палец в отверстие...</p>
      <p style={{ textAlign: "right" }}>4.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page3" />
        <ForwardLink href="/page5" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710018763/the-lighthouse-script/poont3sfxnt4fxzphwor.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page5;
